import DisplayNotifications from 'modules/terminal/pages/DisplayNotifications';
import DisplayBillingInfo from '../pages/DisplayBillingInfo';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import {
  AcceptReleaseRight,
  DeclineReleaseRight,
  TransferReleaseRight,
  UseCases,
  SearchContainers,
  RevokeReleaseRight,
} from '../pages';

type Props = React.ComponentPropsWithoutRef<'div'> & {};

const BetaReleasePartyRoutes: React.FunctionComponent<Props> = () => {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.ACCEPT_RELEASE_RIGHT} element={<AcceptReleaseRight />} />
      <Route path={ROUTE_PATHS.REVOKE_RELEASE_RIGHT} element={<RevokeReleaseRight />} />
      <Route path={ROUTE_PATHS.TRANSFER_RELEASE_RIGHT} element={<TransferReleaseRight />} />
      <Route path={ROUTE_PATHS.DECLINE_RELEASE_RIGHT} element={<DeclineReleaseRight />} />
      <Route path={ROUTE_PATHS.DISPLAY_NOTIFICATIONS} element={<DisplayNotifications />} />
      <Route path={ROUTE_PATHS.DISPLAY_BILLING_INFO} element={<DisplayBillingInfo />} />
      <Route path={ROUTE_PATHS.SEARCH_CONTAINERS} element={<SearchContainers />} />
      <Route path={ROUTE_PATHS.BASE_ROUTE} element={<UseCases />} />
    </Routes>
  );
};

export default BetaReleasePartyRoutes;
